<template>
  <div class="advertisement-main div-layout">
    <module-title title="课桌广告" />
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane v-for="item of sourcenNav" :key="item.code" :label="item.name" :name="item.code">
        <table-list
          v-if="tableLoading"
          :table-data="propsTable.sourceList"
          :props-table="propsTable"
          @getData="getInfo"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import TableList from './tableList.vue';

import { getAdvertisingsList } from '@/api/productOperation/mrDesk/prosepoems';
import {
  getDictsType
} from '@/api/productOperation/common/applicationManage';
export default {
  name: 'Advertisement',
  components: {
    TableList
  },
  data() {
    return {
      activeName: '',
      sourcenNav: [],

      propsTable: {
        sourceList: [],
        locationId: '',
        imgwh: '',
        locationName: '',
        total: 0,
        pageNum: 1,
        pageSize: 10,
        listLoading: false // 表格刷新loading
      },
      init: {
        locationId: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      tableLoading: false
    };
  },
  watch: {
    propsTable: {
      handler(val) {
        if (val) {
          this.tableLoading = true;
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getSource();
  },
  methods: {
    getSource() {
      getDictsType('location_type')
        .then(result => {
          this.sourcenNav = result.data.sort(function(a, b) {
            return a.seq - b.seq;
          });
          this.init.locationId = result.data[0].code;
          this.activeName = result.data[0].code;
          this.propsTable.locationId = result.data[0].code;
          this.propsTable.locationName = result.data[0].name;
          this.propsTable.imgwh = result.data[0].remark;
          this.getInfo(this.init);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取列表
    getInfo(val) {
      var option = {
        pageNum: val.pageNum,
        pageSize: val.pageSize,
        locationId: val.locationId
      };
      this.propsTable.sourceList = [];
      this.tableLoading = false;
      getAdvertisingsList(option)
        .then(res => {
          this.propsTable.listLoading = true;
          if (res.data === null || res.data === '' || res.data === 'undefind') {
            this.propsTable.sourceList = [];
            this.tableLoading = true;
          } else {
            this.propsTable.total = res.data.total;
            this.propsTable.pageNum = val.pageNum;
            this.propsTable.sourceList = res.data.list;
            this.tableLoading = true;
          }
          this.propsTable.listLoading = false;
        })
        .catch(err => {
          this.$message({
            locationId: 'warning',
            message: '暂无数据'
          });
          this.propsTable.listLoading = false;
          console.log(err);
        });
    },
    handleTabClick(tab, event) {
      this.propsTable.locationId = tab.name;
      this.propsTable.locationName = tab.label;
      this.init.locationId = tab.name;
      this.sourcenNav.forEach(item => {
        if (item.code === tab.name) {
          this.propsTable.imgwh = item.remark;
        }
      });
      this.getInfo(this.init);
    }
  }
};
</script>
<style lang="scss" scoped>
.questionManage {
  padding-bottom: 20px;
}

.dialogMain {
  max-height: 470px;
  overflow-y: auto;
}
.link {
  color: #409eff;
  text-decoration: underline;
}
.edit-form-input {
  width: 150px;
}
.handle-form-input {
  width: 80%;
}

.upload-picture {
  float: right;
}

.picture-wrapper {
  width: 80%;
  height: 100px;
  margin-top: 10px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
</style>
<style lang="scss">
.advertisement-main{
  .el-tabs__nav-wrap{
   padding-left: 20px !important;
  }
}
</style>
